/* ─────────────────────────────────────────
   THE NINTH ASCENSION — Waitlist JS
   ───────────────────────────────────────── */

(function () {
  'use strict';

  // ── Entrance Animations ──────────────────
  function initAnimations() {
    var elements = document.querySelectorAll('[data-animate]');

    if (!elements.length) return;

    // Stagger each element using its data-delay attribute
    elements.forEach(function (el) {
      var delay = parseInt(el.getAttribute('data-delay') || '0', 10);

      setTimeout(function () {
        el.classList.add('is-visible');
      }, delay + 100);
    });

    // Also handle bottom-mark separately
    var bottomMark = document.querySelector('.bottom-mark');
    if (bottomMark) {
      setTimeout(function () {
        bottomMark.style.opacity = '1';
        bottomMark.style.transition = 'opacity 1s ease';
      }, 900);
    }
  }

  // ── Success State Handling ───────────────
  function initFormSuccess() {
    var success = document.querySelector('.form-success');
    if (!success) return;

    // Scroll smoothly to the success message
    setTimeout(function () {
      success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 200);

    // Optionally hide the form fields on success
    var form = document.querySelector('.waitlist-form');
    if (form) {
      var row = form.querySelector('.form-row');
      if (row) {
        row.style.opacity = '0';
        row.style.transition = 'opacity 0.5s ease';
        row.style.pointerEvents = 'none';
        setTimeout(function () { row.style.display = 'none'; }, 500);
      }
    }
  }

  // ── Subtle parallax on scroll ────────────
  function initParallax() {
    var grain = document.querySelector('.grain-overlay');
    if (!grain) return;

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          grain.style.transform = 'translateY(' + (scrollY * 0.15) + 'px)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Init ─────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initAnimations();
    initFormSuccess();
    initParallax();
  });

})();
